"use strict";
/*!
 FWF excellent=austria

 (c) 2023-2024 APA Austria Presse Agentur
 
 All Rights Reserved
*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const glide_1 = __importDefault(require("@glidejs/glide"));
class Website {
    constructor(type) {
        this.clickFunction = (event) => {
            var _a;
            var id = (_a = event.target.closest('[data-' + this.type + ']')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-' + this.type);
            if (id) {
                let optionList = document.querySelectorAll('.apa-dropdown' + this.type + ' .apa-dropdown-options a');
                let selected = document.querySelector('.apa-dropdown' + this.type + ' .apa-dropdown-selected');
                optionList.forEach((option) => {
                    if (option.getAttribute('data-' + this.type) == id) {
                        selected.innerHTML = option.innerHTML;
                    }
                });
                this.handleClick(id, false);
            }
        };
        this.type = type;
        this.upperCaseType = this.type.charAt(0).toUpperCase() + this.type.slice(1);
        this.clusterBoxElements = [];
        this.glider = new glide_1.default('.glide-' + this.type, {
            type: 'carousel',
            startAt: 0,
            perView: 5,
            peek: 0,
            focusAt: 'center',
            bound: true,
            gap: 10,
            rewind: false,
            breakpoints: {
                1950: {
                    perView: 4.1
                },
                1700: {
                    perView: 3.1
                },
                1250: {
                    perView: 2.5
                },
                1150: {
                    perView: 2.1
                },
                800: {
                    perView: 1.5
                },
                600: {
                    perView: 1.4
                },
                500: {
                    perView: 1.1
                }
            }
        });
        window.addEventListener('DOMContentLoaded', () => {
            if (this.type == 'emerging') {
                this.loadSVG('content/map_emerging.svg');
            }
            else {
                this.loadSVG('content/map.svg');
            }
            this.initGlider();
        });
    }
    initGlider() {
        this.glider.mount();
    }
    handleDropdown(dropdown) {
        const selected = dropdown.querySelector('.apa-dropdown-selected');
        const options = dropdown.querySelector('.apa-dropdown-options');
        const optionList = options.querySelectorAll('.apa-dropdown-option');
        function toggleOptions() {
            options.style.display = options.style.display === 'block' ? 'none' : 'block';
            selected.classList.toggle("apa-active");
        }
        function setSelected(option) {
            selected.innerHTML = option.innerHTML;
            toggleOptions();
        }
        selected.addEventListener('click', (e) => {
            e.preventDefault();
            toggleOptions();
        });
        optionList.forEach((option) => {
            option.addEventListener('click', (event) => {
                event.preventDefault();
                setSelected(option);
                var id = event.target.getAttribute('data-' + this.type);
                if (id)
                    this.handleClick(id);
            });
        });
        document.addEventListener('click', (e) => {
            if (!dropdown.contains(e.target)) {
                options.style.display = 'none';
            }
        });
    }
    loadSVG(url) {
        fetch(url)
            .then(response => response.text())
            .then(svg => {
            if (!svg) {
                throw new Error('Invalid SVG');
            }
            const svgContainer = document.querySelector('#apa-svg-' + this.type);
            if (svgContainer)
                svgContainer.innerHTML = svg;
            this.bindEvents();
        });
    }
    bindPublicEvents() {
        window.addEventListener('DOMContentLoaded', () => {
            // Main switch for type (cluster or emerging)
            var links = document.querySelectorAll('.apa-mainswitch a');
            for (var i = 0; i < links.length; i++) {
                links[i].addEventListener('click', (event) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    if (!event)
                        return false;
                    const target = event.target;
                    const type = target.getAttribute('data-type');
                    if (type == 'cluster') {
                        (_a = document.querySelector('.apa-mainswitch a[data-type="emerging"]')) === null || _a === void 0 ? void 0 : _a.classList.remove('apa-selected');
                        (_b = document.querySelector('.apa-map-emerging')) === null || _b === void 0 ? void 0 : _b.classList.remove('apa-visible');
                        (_c = document.querySelector('.apa-emergingdetails')) === null || _c === void 0 ? void 0 : _c.classList.remove('apa-visible');
                    }
                    else if (type == 'emerging') {
                        (_d = document.querySelector('.apa-mainswitch a[data-type="cluster"]')) === null || _d === void 0 ? void 0 : _d.classList.remove('apa-selected');
                        (_e = document.querySelector('.apa-map-cluster')) === null || _e === void 0 ? void 0 : _e.classList.remove('apa-visible');
                        (_f = document.querySelector('.apa-clusterdetails')) === null || _f === void 0 ? void 0 : _f.classList.remove('apa-visible');
                    }
                    (_g = document.querySelector('.apa-mainswitch a[data-type="' + type + '"]')) === null || _g === void 0 ? void 0 : _g.classList.add('apa-selected');
                    (_h = document.querySelector('.apa-map-' + type)) === null || _h === void 0 ? void 0 : _h.classList.add('apa-visible');
                    (_j = document.querySelector('.apa-' + type + 'details')) === null || _j === void 0 ? void 0 : _j.classList.add('apa-visible');
                    // bug with carousel not shown
                    window.dispatchEvent(new Event('resize'));
                });
            }
            // show more button
            document.querySelector('.apa-showmore').addEventListener('click', (event) => {
                document.querySelector('.apa-showmore').style.display = 'none';
                document.querySelector('.apa-textbox p').style.display = 'block';
            });
            // back anchor
            var backAnchor = document.querySelector('.apa-backanchor');
            if (!backAnchor)
                return false;
            backAnchor.addEventListener('click', (e) => {
                e.preventDefault();
                var element = document.querySelector('.apa-map');
                if (element)
                    this.scrollToElement(element);
            });
            var map = document.querySelector('.apa-map');
            function toggleElementVisibility() {
                const mapRect = map.getBoundingClientRect();
                if (window.scrollY > (mapRect.top + mapRect.height + 800)) {
                    // show
                    backAnchor.classList.add('apa-visible');
                    backAnchor.classList.remove('apa-hidden');
                }
                else {
                    // hide
                    backAnchor.classList.add('apa-hidden');
                    backAnchor.classList.remove('apa-visible');
                }
            }
            window.addEventListener('scroll', toggleElementVisibility);
            window.addEventListener('resize', toggleElementVisibility);
        });
    }
    bindEvents() {
        // clusterbox
        this.killBindClusterBoxEvents();
        // navigation
        var links = document.querySelectorAll('.apa-' + this.type + 'nav a');
        for (var i = 0; i < links.length; i++) {
            links[i].addEventListener('click', (event) => {
                var id = event.target.getAttribute('data-' + this.type);
                if (id)
                    this.handleClick(id);
            });
            links[i].addEventListener('touchstart', (event) => {
                var id = event.target.getAttribute('data-' + this.type);
                if (id)
                    this.handleClick(id);
            });
        }
        // dropdown
        const dropdown = document.querySelector('.apa-dropdown' + this.type);
        this.handleDropdown(dropdown);
        window.addEventListener('resize', () => {
            this.glider.update({ startAt: 0 });
        });
    }
    handleClick(cluster, dropdownClicked = true) {
        const link = document.querySelector('.apa-dropdown-option[data-' + this.type + '="' + cluster + '"]');
        if (!link)
            return false;
        if (!cluster)
            return false;
        this.resetCluster();
        if (document.querySelector('#' + cluster))
            document.querySelector('#' + cluster).style.display = 'block';
        link.classList.add('apa-active');
        const clusterElements = document.querySelectorAll('.apa-' + this.type + 'box_' + cluster);
        clusterElements.forEach((element) => {
            element.classList.add('apa-active');
        });
        var position = parseInt(cluster.replace(this.upperCaseType, ''), 10) - 1;
        if (dropdownClicked) {
            const slides = document.querySelector('.glide__slides');
            slides.classList.add('slider-transition');
            // Entfernen Sie die Klasse nach einer kurzen Verzögerung, um die Transition abzuschließen
            setTimeout(() => {
                slides.classList.remove('slider-transition');
            }, 1000);
        }
        this.glider.update({ startAt: position });
        this.killBindClusterBoxEvents();
    }
    killBindClusterBoxEvents() {
        this.clusterBoxElements.forEach((element) => {
            element.removeEventListener('click', this.clickFunction);
        });
        this.clusterBoxElements = [];
        var clusterElements = document.querySelectorAll('.apa-' + this.type + 'box');
        clusterElements.forEach((element) => {
            element.addEventListener('click', this.clickFunction);
            this.clusterBoxElements.push(element);
        });
    }
    scrollToElement(element) {
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: element.offsetTop
        });
    }
    resetCluster() {
        document.querySelectorAll('.apa-dropdown-option').forEach((link) => {
            link.classList.remove('apa-active');
        });
        document.querySelectorAll('.apa-' + this.type + 'nav a').forEach((link) => {
            link.classList.remove('apa-active');
        });
        document.querySelectorAll('.apa-' + this.type + 'box').forEach((link) => {
            link.classList.remove('apa-active');
        });
        for (var i = 1; i <= 20; i++) {
            let element = document.querySelector('#' + this.upperCaseType + '0' + i);
            if (element)
                element.style.display = 'none';
        }
        let elementAll = document.querySelector('#' + this.upperCaseType + '_all');
        if (elementAll)
            elementAll.style.display = 'none';
    }
}
let firstInstance = new Website('cluster');
new Website('emerging');
firstInstance.bindPublicEvents();
